// import { useState, useEffect } from "react";
// import { MdEditDocument } from "react-icons/md";
// import { useQuery, useMutation } from "@tanstack/react-query";
// import { useForm } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { toast } from "react-toastify";

// // Image
// import ProjectImage from "../image/profile-view.jpg";

// // Child Components
// import Input from "../ChildComponents/Input";
// import SubHead from "../ChildComponents/SubHead";
// import CompanyTitle from "../ChildComponents/CompanyTitle";
// import Tab from "../ChildComponents/Tab";
// import BrandButton from "../ChildComponents/BrandButton";
// import Loading from "../ChildComponents/Loading";

// // API Hooks
// import { useSingleUser, useUpdateUser } from "../store/api/profileApi";

// // Validation Schema
// import { profileSchema } from "../Components/validation/profileValidation";

// function Profile() {
//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//     reset,
//     watch,
//   } = useForm({
//     resolver: yupResolver(profileSchema),
//   });

//   const getSingleUser = useSingleUser();
//   const {
//     data: profileData,
//     isLoading: isProfileLoading,
//     error: profileError,
//     refetch,
//   } = useQuery({ queryKey: ["single-profile"], queryFn: getSingleUser });

//   const profile = profileData?.user;
//   const updateUser = useUpdateUser(profile?._id);

//   useEffect(() => {
//     reset({
//       fullName: profile?.fullName || "",
//       email: profile?.email || "",
//       oldPassword: "",
//       password: "",
//       retypePassword: "",
//     });
//   }, [profileData, reset]);

//   const [inputView, setInputView] = useState("");
//   const nameValue = watch("email");

//   const viewHandler = (field) => {
//     refetch();
//     reset();
//     setInputView(field);
//   };

//   const [loading, setLoading] = useState(false);
//   const mutation = useMutation({
//     mutationFn: (data) => updateUser(data),
//     onSuccess: () => {
//       toast.success("Profile updated successfully");
//       setLoading(false);
//       reset();
//       viewHandler("");
//     },
//     onError: (error) => {
//       toast.error(error?.message || "Update failed");
//       setLoading(false);
//     },
//   });

//   const onSubmit = (formData) => {
//     setLoading(true);
//     if (formData.fullName === "") {
//       setLoading(false);
//       return toast.error("Full Name is Empty");
//     }
//     if (formData.email === "") {
//       setLoading(false);
//       return toast.error("Email is Empty");
//     }
//     if (formData.password !== formData.retypePassword) {
//       setLoading(false);
//       return toast.error("New Password and Re-type Not Match");
//     }
//     mutation.mutate({
//       fullName: formData.fullName,
//       email: formData.email,
//       previousPassword: formData.oldPassword,
//       password: formData.password,
//     });
//   };

//   if (isProfileLoading) {
//     return <Loading />;
//   }

//   return (
//     <div className="my-5 pb-5">
//       <form onSubmit={handleSubmit(onSubmit)}>
//         <div className="container">
//           <div className="row">
//             <div className="col-sm-12 col-md-6">
//               <div className="profile-view d-flex">
//                 <img className="img-fluid shadow" src={ProjectImage} alt="" />
//                 <div className="mt-3 ms-3">
//                   <div className="profile-title d-flex align-items-center">
//                     {inputView === "name" ? (
//                       <Input
//                         icon="title"
//                         {...register("fullName")}
//                         error={errors.fullName?.message}
//                         type="text"
//                         placeholder="Your Name Here"
//                         label="Name"
//                       />
//                     ) : (
//                       <>
//                         <p className="mb-0">
//                           {profile?.fullName || "Not Set Yet"}
//                         </p>
//                         <button
//                           onClick={() => viewHandler("name")}
//                           className="btn text-dark"
//                         >
//                           <MdEditDocument />
//                         </button>
//                       </>
//                     )}
//                   </div>
//                   <small className="mb-0 h6 text-dark">
//                     --- {profile?.role}
//                   </small>
//                   <div className="mt-4">
//                     <CompanyTitle titles={[`${profile?.userStatus}`]} />
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="col-sm-12 col-md-6">
//               <p className="joint mt-3 mb-0">
//                 Joining Date:{" "}
//                 <span>
//                   {new Date(profile?.createdAt).toLocaleDateString("en-US", {
//                     day: "numeric",
//                     month: "long",
//                     year: "numeric",
//                   })}
//                 </span>
//               </p>
//               <p className="joint mb-0">
//                 Last Update Date:{" "}
//                 <span>
//                   {new Date(profile?.updatedAt).toLocaleDateString("en-US", {
//                     day: "numeric",
//                     month: "long",
//                     year: "numeric",
//                   })}
//                 </span>
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="container p-2">
//           <div className="row mt-3">
//             <div className="col-sm-12 col-md-6 col-xl-4 mb-3">
//               <SubHead
//                 title="User Information"
//                 textClass="text-success fw-bold"
//                 class="border-bottom border-1 pb-1 mb-2"
//               />

//               {inputView === "email" ? (
//                 <Input
//                   icon="title"
//                   {...register("email")}
//                   error={errors.email?.message}
//                   type="text"
//                   placeholder="admin@email.com"
//                   label="Email"
//                 />
//               ) : (
//                 <Tab
//                   class="border-primary"
//                   fontClass="f-13"
//                   title={`Email - ${profile?.email}`}
//                   onClick={() => viewHandler("email")}
//                 />
//               )}

//               {inputView === "password" ? (
//                 <>
//                   <Input
//                     icon="title"
//                     {...register("oldPassword")}
//                     error={errors.oldPassword?.message}
//                     type="password"
//                     placeholder="******"
//                     label="Previous Password"
//                   />
//                   <Input
//                     icon="title"
//                     {...register("password")}
//                     error={errors.password?.message}
//                     type="password"
//                     placeholder="******"
//                     label="New Password"
//                   />
//                   <Input
//                     icon="title"
//                     {...register("retypePassword")}
//                     error={errors.retypePassword?.message}
//                     type="password"
//                     placeholder="******"
//                     label="Re-Type Password"
//                   />
//                 </>
//               ) : (
//                 <Tab
//                   class="border-primary"
//                   fontClass="f-13"
//                   title="Password - ********"
//                   onClick={() => viewHandler("password")}
//                 />
//               )}

//               {inputView && (
//                 <div className="d-flex mt-3">
//                   <BrandButton
//                     type="submit"
//                     title={loading ? "Loading..." : "Save Changes"}
//                     class="me-3"
//                     // onClick={handleSubmit(onSubmit)}
//                     // onClick={() => submitHandler()}
//                   />
//                   <BrandButton
//                     type="button"
//                     title="Cancel"
//                     class="me-3"
//                     onClick={() => viewHandler("")}
//                   />
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </form>
//     </div>
//   );
// }

// export default Profile;

import { useState, useEffect } from "react";
import { MdEditDocument } from "react-icons/md";
import { useQuery, useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";

// Image
import ProjectImage from "../image/profile-view.jpg";

// Child Components
import Input from "../ChildComponents/Input";
import BrandButton from "../ChildComponents/BrandButton";
import Loading from "../ChildComponents/Loading";

// API Hooks
import { useSingleUser, useUpdateUser } from "../store/api/profileApi";

// Validation Schema
import { profileSchema } from "../Components/validation/profileValidation";

function Profile() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(profileSchema),
  });

  const getSingleUser = useSingleUser();
  const {
    data: profileData,
    isLoading: isProfileLoading,
    refetch,
  } = useQuery({ queryKey: ["single-profile"], queryFn: getSingleUser });

  const profile = profileData?.user;
  const updateUser = useUpdateUser(profile?._id);

  useEffect(() => {
    reset({
      fullName: profile?.fullName || "",
      email: profile?.email || "",
      oldPassword: "",
      password: "",
      retypePassword: "",
    });
  }, [profileData, reset, profile]);

  const [inputView, setInputView] = useState("");

  const viewHandler = (field) => {
    refetch();
    reset();
    setInputView(field);
  };

  const [loading, setLoading] = useState(false);
  const mutation = useMutation({
    mutationFn: (data) => updateUser(data),
    onSuccess: () => {
      toast.success("Profile updated successfully");
      setLoading(false);
      reset();
      viewHandler("");
    },
    onError: (error) => {
      toast.error(error?.message || "Update failed");
      setLoading(false);
    },
  });

  const onSubmit = (formData) => {
    setLoading(true);
    if (formData.fullName === "") {
      setLoading(false);
      return toast.error("Full Name is Empty");
    }
    if (formData.email === "") {
      setLoading(false);
      return toast.error("Email is Empty");
    }
    if (formData.password !== formData.retypePassword) {
      setLoading(false);
      return toast.error("New Password and Re-type Not Match");
    }
    mutation.mutate({
      fullName: formData.fullName,
      email: formData.email,
      previousPassword: formData.oldPassword,
      password: formData.password,
    });
  };

  if (isProfileLoading) {
    return <Loading />;
  }

  return (
    <div
      className="py-4"
      style={{
        background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
        minHeight: "100vh",
      }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="container">
          {/* Header Card */}
          <div className="card shadow-lg border-0 rounded-4 mb-4 overflow-hidden">
            {/* Gradient Banner */}
            <div
              style={{
                height: "120px",
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              }}
            ></div>

            <div className="card-body px-4 pb-4">
              <div
                className="row align-items-end"
                style={{ marginTop: "-80px" }}
              >
                <div className="col-md-8">
                  <div className="d-flex align-items-end gap-3">
                    {/* Profile Image */}
                    <div className="position-relative">
                      <img
                        src={ProjectImage}
                        alt="Profile"
                        className="rounded-4 border border-4 border-white shadow-lg"
                        style={{
                          width: "130px",
                          height: "130px",
                          objectFit: "cover",
                        }}
                      />
                      <span
                        className="position-absolute bottom-0 end-0 bg-success rounded-circle border border-3 border-white"
                        style={{ width: "25px", height: "25px" }}
                      ></span>
                    </div>

                    {/* Name & Role */}
                    <div className="mb-2">
                      <div className="d-flex align-items-center gap-2 mb-1">
                        {inputView === "name" ? (
                          <Input
                            {...register("fullName")}
                            error={errors.fullName?.message}
                            type="text"
                            placeholder="Your Name Here"
                            label="Name"
                          />
                        ) : (
                          <>
                            <h2
                              className="mb-0 fw-bold"
                              style={{ color: "#2d3748" }}
                            >
                              {profile?.fullName || "Not Set Yet"}
                            </h2>
                            <button
                              type="button"
                              onClick={() => viewHandler("name")}
                              className="btn btn-sm btn-light rounded-circle p-2"
                              style={{ width: "36px", height: "36px" }}
                            >
                              <MdEditDocument size={18} />
                            </button>
                          </>
                        )}
                      </div>
                      <p className="text-muted mb-2">— {profile?.role}</p>
                      <span className="badge bg-success-subtle text-success px-3 py-2 rounded-pill fw-semibold">
                        {profile?.userStatus}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Dates */}
                <div className="col-md-4 mt-3 mt-md-0">
                  <div className="d-flex flex-column gap-2">
                    <div className="d-flex align-items-center gap-2 text-muted small">
                      <i className="bi bi-calendar-event"></i>
                      <span className="fw-semibold">Joined:</span>
                      <span>
                        {new Date(profile?.createdAt).toLocaleDateString(
                          "en-US",
                          {
                            day: "numeric",
                            month: "short",
                            year: "numeric",
                          }
                        )}
                      </span>
                    </div>
                    <div className="d-flex align-items-center gap-2 text-muted small">
                      <i className="bi bi-clock-history"></i>
                      <span className="fw-semibold">Updated:</span>
                      <span>
                        {new Date(profile?.updatedAt).toLocaleDateString(
                          "en-US",
                          {
                            day: "numeric",
                            month: "short",
                            year: "numeric",
                          }
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* User Information Card */}
          <div className="card shadow-lg border-0 rounded-4">
            <div className="card-body p-4">
              <div className="d-flex align-items-center gap-2 mb-4">
                <div
                  className="rounded-2"
                  style={{
                    width: "4px",
                    height: "32px",
                    background:
                      "linear-gradient(180deg, #667eea 0%, #764ba2 100%)",
                  }}
                ></div>
                <h4 className="mb-0 fw-bold" style={{ color: "#2d3748" }}>
                  User Information
                </h4>
              </div>

              <div className="row">
                <div className="col-lg-6">
                  {/* Email Section */}
                  <div
                    className="card border-0 bg-light mb-3 hover-card"
                    style={{ transition: "all 0.3s ease" }}
                  >
                    <div className="card-body p-3">
                      <div className="d-flex align-items-center gap-3">
                        <div
                          className="rounded-3 d-flex align-items-center justify-content-center"
                          style={{
                            width: "48px",
                            height: "48px",
                            background:
                              "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          }}
                        >
                          <i className="bi bi-envelope-fill text-white"></i>
                        </div>
                        <div className="flex-grow-1">
                          <small className="text-muted d-block mb-1 fw-semibold">
                            Email Address
                          </small>
                          {inputView === "email" ? (
                            <Input
                              {...register("email")}
                              error={errors.email?.message}
                              type="text"
                              placeholder="admin@email.com"
                              label="Email"
                            />
                          ) : (
                            <div className="d-flex align-items-center justify-content-between">
                              <p
                                className="mb-0 fw-semibold"
                                style={{ color: "#2d3748" }}
                              >
                                {profile?.email}
                              </p>
                              <button
                                type="button"
                                onClick={() => viewHandler("email")}
                                className="btn btn-sm btn-light rounded-circle p-2"
                                style={{ width: "32px", height: "32px" }}
                              >
                                <MdEditDocument size={16} />
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Password Section */}
                  <div
                    className="card border-0 bg-light hover-card"
                    style={{ transition: "all 0.3s ease" }}
                  >
                    <div className="card-body p-3">
                      <div className="d-flex align-items-start gap-3">
                        <div
                          className="rounded-3 d-flex align-items-center justify-content-center"
                          style={{
                            width: "48px",
                            height: "48px",
                            background:
                              "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                          }}
                        >
                          <i className="bi bi-lock-fill text-white"></i>
                        </div>
                        <div className="flex-grow-1">
                          <small className="text-muted d-block mb-1 fw-semibold">
                            Password
                          </small>
                          {inputView === "password" ? (
                            <>
                              <Input
                                {...register("oldPassword")}
                                error={errors.oldPassword?.message}
                                type="password"
                                placeholder="******"
                                label="Current Password"
                              />
                              <Input
                                {...register("password")}
                                error={errors.password?.message}
                                type="password"
                                placeholder="******"
                                label="New Password"
                              />
                              <Input
                                {...register("retypePassword")}
                                error={errors.retypePassword?.message}
                                type="password"
                                placeholder="******"
                                label="Confirm Password"
                              />
                            </>
                          ) : (
                            <div className="d-flex align-items-center justify-content-between">
                              <p
                                className="mb-0 fw-semibold"
                                style={{ color: "#2d3748" }}
                              >
                                ••••••••
                              </p>
                              <button
                                type="button"
                                onClick={() => viewHandler("password")}
                                className="btn btn-sm btn-light rounded-circle p-2"
                                style={{ width: "32px", height: "32px" }}
                              >
                                <MdEditDocument size={16} />
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  {inputView && (
                    <div className="d-flex gap-2 mt-4">
                      <BrandButton
                        type="submit"
                        title={loading ? "Loading..." : "Save Changes"}
                        class="btn btn-primary px-4 py-2 rounded-3 fw-semibold shadow-sm"
                        style={{
                          background:
                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          border: "none",
                        }}
                      />
                      <BrandButton
                        type="button"
                        title="Cancel"
                        class="btn btn-light px-4 py-2 rounded-3 fw-semibold"
                        onClick={() => viewHandler("")}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Info Alert */}
          <div
            className="alert alert-info border-0 rounded-4 mt-4 shadow-sm"
            style={{
              background: "linear-gradient(135deg, #e0f2fe 0%, #dbeafe 100%)",
            }}
          >
            <div className="d-flex align-items-start gap-2">
              <i className="bi bi-lightbulb-fill text-primary"></i>
              <div>
                <span className="fw-semibold">Tip:</span> Keep your profile
                information up-to-date to ensure seamless collaboration with
                your team.
              </div>
            </div>
          </div>
        </div>
      </form>

      <style jsx>{`
        .hover-card:hover {
          background-color: #fff !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          transform: translateY(-2px);
        }

        .btn-light:hover {
          background-color: #e9ecef;
        }

        .rounded-4 {
          border-radius: 1rem !important;
        }
      `}</style>
    </div>
  );
}

export default Profile;
